export default __webpack_public_path__ + "static/media/IRANSansWeb.9ffdcda0.woff";